<div class="body">
    <div class="col-12 pt-4" *ngIf="formulaire">
        <form [formGroup]="formulaire">
            <h4 class="ml-2 pt-3">A - Les moyens</h4>
            <h5 class="mt-4 ml-2">A.1 - Les personnels de l'association en charge des activités de l'Aide Aux Victimes
                (tous dispositifs AAV)</h5>
            <div class="card-header text-muted">
                <i>Renseigner, pour chacune des fonctions, et selon le statut des personnels AAV,
                    le nombre de personnes en poste au 31 décembre ainsi que leur temps de travail en 
                    équivalent temps plein travaillé (ETPT) sur l'année
                </i>
            </div>
            <h6 class="mt-4 ml-2"><b>a - Salariés de l'association en charge des activités de l'Aide Aux Victimes</b>
            </h6>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-A1a" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Fonction</th>
                                        <th colspan="2" class="text-center align-middle">Salariés en CDI</th>
                                        <th colspan="2" class="text-center align-middle">Salariés en CDD</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center align-middle">Effectif 31/12</th>
                                        <th class="text-center align-middle">ETPT</th>
                                        <th class="text-center align-middle">Effectif 31/12</th>
                                        <th class="text-center align-middle">ETPT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Accueillants Aide Aux Victimes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiAav" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiAav"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddAav" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddAav"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Juristes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiJur" classeSupplementaire="text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlA78']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA78">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiJur"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA79']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA79">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddJur" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA86']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA86">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddJur"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA87']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA87">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Psychologues
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiPsy" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA80']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA80">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiPsy"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA81']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA81">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddPsy" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA88']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA88">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddPsy"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA89']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA89">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Travailleurs Sociaux
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiWsoc" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA82']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA82">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiWsoc"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA83']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA83">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddWsoc" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA90']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA90">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddWsoc"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA91']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA91">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Autres intervenants
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiAutrInterv" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiAutrInterv"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddAutrInterv" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddAutrInterv"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Directeur, chef de
                                            service
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiDir" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiDir"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddDir" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddDir"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Comptable, secrétaire,
                                            Personnel d'entretien
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiComptsecr" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiComptsecr"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddComptsecr" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddComptsecr"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 7%">Autres fonctions
                                            transversales de support (ex : informaticien)
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCdiAutrSupport" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCdiAutrSupport"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbCddAutrSupport" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" 
                                                libelle="vide" label="aaEtpCddAutrSupport"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" class="text-center align-middle pl-2" style="width: 9%">
                                            <b> Total</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauA1a()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                label="aaNbCdiTot" classeSupplementaire="integer-input-total text-right"
                                                libelle="vide" [erreursCroisees]="['ctrlA9', 'ctrlA84']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA9">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA84">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA9'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                label="aaEtpCdiTot"
                                                classeSupplInput="integer-input-total text-right"
                                                [erreursCroisees]="['ctrlA10', 'ctrlA85']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA10">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA85">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA10'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                label="aaNbCddTot" classeSupplementaire="integer-input-total text-right"
                                                libelle="vide" [erreursCroisees]="['ctrlA11', 'ctrlA92']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA11">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA92">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA11'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 11%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                label="aaEtpCddTot"
                                                classeSupplInput="integer-input-total text-right"
                                                [erreursCroisees]="['ctrlA12', 'ctrlA93']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA12">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA93">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA12'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div style="page-break-before: always"></div>

            <h6 class="mt-5 ml-2"><b>b – Prestataires engagés par l'association en charge des activités de l'Aide Aux
                    Victimes</b>
            </h6>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-A1b" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Fonction</th>
                                        <th colspan="2" class="text-center align-middle">Prestataires</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center align-middle">Effectif 31/12</th>
                                        <th class="text-center align-middle">ETPT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Accueillants Aide Aux Victimes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaAav" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaAav"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Juristes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaJur" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA94']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA94">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaJur"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA95']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA95">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Psychologues
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaPsy" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA96']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA96">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaPsy"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA97']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA97">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Travailleurs Sociaux
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaWsoc" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA98']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA98">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaWsoc"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA99']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA99">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Autres intervenants
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaAutrInterv" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaAutrInterv"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Directeur, chef de
                                            service
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaDir" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaDir"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Comptable,
                                            secrétaire,
                                            Personnel d'entretien
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaComptsecr" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaComptsecr"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Autres fonctions
                                            transversales de support (ex : informaticien)
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbPrestaAutrSupport" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpPrestaAutrSupport"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" class="text-center align-middle pl-2" style="width: 60%">
                                            <b> Total  </b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauA1b()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                label="aaNbPrestaTot"
                                                classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlA13', 'ctrlA100']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA13">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA100">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA13'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                label="aaEtpPrestaTot"
                                                classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA14', 'ctrlA101']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA14">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA101">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA14'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div style="page-break-before: always"></div>

            <h6 class="mt-5 ml-2"><b>c – Bénévoles au service de l'association en charge des activités de l'Aide Aux
                    Victimes</b>
            </h6>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-A1c" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Fonction</th>
                                        <th colspan="2" class="text-center align-middle">Bénévoles</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center align-middle">Effectif 31/12</th>
                                        <th class="text-center align-middle">ETPT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Accueillants Aide Aux Victimes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlAav" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlAav"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Juristes
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlJur" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA102']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA102">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlJur"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA45']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA45">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Psychologues
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlPsy" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA46']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA46">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlPsy"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA47']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA47">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Travailleurs Sociaux
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlWsoc" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlA48']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA48">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlWsoc"
                                                classeSupplInput="text-right" [erreursCroisees]="['ctrlA49']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA49">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Autres intervenants
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlAutrInterv" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlAutrInterv"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Directeur, chef de
                                            service
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlDir" classeSupplementaire="text-right" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlDir"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Comptable,
                                            secrétaire,
                                            Personnel d'entretien
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlComptsecr" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlComptsecr"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 60%">Autres fonctions
                                            transversales de support (ex : informaticien)
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999"
                                                label="aaNbBnvlAutrSupport" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="999" libelle="vide" 
                                                label="aaEtpBnvlAutrSupport"
                                                classeSupplInput="text-right">
                                            </bis-float-mask-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" class="text-center align-middle pl-2" style="width: 60%">
                                            <b> Total  </b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauA1c()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                label="aaNbBnvlTot"
                                                classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlA15', 'ctrlA50']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA15">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA50">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA15'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                label="aaEtpBnvlTot"
                                                classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA16', 'ctrlA51']">
                                            </bis-float-mask-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA16">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlA51">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertA16'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div style="page-break-before: always"></div>

            <h5 class="mt-5 ml-2">A.2 - Les personnels de l'association pour toutes les activités exercées</h5>

            <div class="form-row mt-2">
                <div class="col-md-12">
                    <bis-filtered-select-inline-input-keypad [rootForm]="formulaire" label="aaAssoUniqAav"
                        nomNomenclature="ouiNon" classeColLabel="col-9" classeColInput="col-3">
                    </bis-filtered-select-inline-input-keypad>
                </div>
            </div>

            <span *ngIf="aaAssoUniqAav === '1'">

                <div class="card-header text-muted">
                    <i>Renseigner, pour chacune des fonctions, et selon le statut des personnels de l'association,
                        le nombre de personnes en poste au 31 décembre ainsi que leur temps de travail en
                        équivalent temps plein travaillé (ETPT) sur l'année
                    </i>
                    <div class="pt-2">
                        <i>Attention, il s'agit pour les trois tableaux qui suivent, de <b>l'ensemble des personnels de
                                l'association</b> et pas
                            uniquement du personnel dédié à l'activité d'aide aux victimes
                        </i>
                    </div>
                </div>
                <h6 class="mt-4 ml-2"><b>a - Ensemble des salariés de l'association</b>
                </h6>
                <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                            <div class="col-md-12">
                                <table id="table-A2a" class="table table-sm m-0 table-bordered">
                                    <thead class="thead-light">
                                        <tr>
                                            <th rowspan="2" class="text-center align-middle"></th>
                                            <th colspan="2" class="text-center align-middle">Salariés en CDI</th>
                                            <th colspan="2" class="text-center align-middle">Salariés en CDD</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center align-middle">Effectif 31/12</th>
                                            <th class="text-center align-middle">ETPT</th>
                                            <th class="text-center align-middle">Effectif 31/12</th>
                                            <th class="text-center align-middle">ETPT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-left align-middle pl-2" style="width: 30%"><b>Ensemble des
                                                    salariés</b>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                    label="aaAssoNbCdi" classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                    [erreursCroisees]="['ctrlA35']">
                                                </bis-integer-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA35">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="99999" libelle="vide" 
                                                    label="aaAssoEtpCdi"
                                                    classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA36']">
                                                </bis-float-mask-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA36">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                    label="aaAssoNbCdd" classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                    [erreursCroisees]="['ctrlA37']">
                                                </bis-integer-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA37">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="99999" libelle="vide" 
                                                    label="aaAssoEtpCdd"
                                                    classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA38']">
                                                </bis-float-mask-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA38">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 30%"><b>dont</b>
                                                juristes
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCdiJur" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCdiJur"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCddJur" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCddJur"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 30%"><b>dont</b>
                                                psychologues
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCdiPsy" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCdiPsy"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCddPsy" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCddPsy"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 30%"><b>dont</b>
                                                travailleurs sociaux
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCdiWsoc" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCdiWsoc"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbCddWsoc" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 15%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpCddWsoc"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <div style="page-break-before: always"></div>

                <h6 class="mt-5 ml-2"><b>b – Ensemble des prestataires de l'association</b>
                </h6>
                <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                            <div class="col-md-12">
                                <table id="table-A2b" class="table table-sm m-0 table-bordered">
                                    <thead class="thead-light">
                                        <tr>
                                            <th rowspan="2" class="text-center align-middle"></th>
                                            <th colspan="2" class="text-center align-middle">Prestataires</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center align-middle">Effectif 31/12</th>
                                            <th class="text-center align-middle">ETPT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-left align-middle pl-2" style="width: 60%"><b>Ensemble des
                                                    prestataires</b>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                    label="aaAssoNbPresta" classeSupplementaire="integer-input-total text-right"
                                                    libelle="vide" [erreursCroisees]="['ctrlA39']">
                                                </bis-integer-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA39">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="99999" libelle="vide" 
                                                    label="aaAssoEtpPresta"
                                                    classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA40']">
                                                </bis-float-mask-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA40">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                juristes
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbPrestaJur" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 12%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpPrestaJur"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                psychologues
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 12%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbPrestaPsy" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 12%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpPrestaPsy"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                travailleurs sociaux
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 12%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbPrestaWsoc" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 12%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpPrestaWsoc"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <h6 class="mt-5 ml-2"><b>c – Ensemble des bénévoles de l'association</b>
                </h6>
                <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                        <div class="form-row">
                            <div class="col-md-12">
                                <table id="table-A2b" class="table table-sm m-0 table-bordered">
                                    <thead class="thead-light">
                                        <tr>
                                            <th rowspan="2" class="text-center align-middle"></th>
                                            <th colspan="2" class="text-center align-middle">Bénévoles</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center align-middle">Effectif 31/12</th>
                                            <th class="text-center align-middle">ETPT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-left align-middle pl-2" style="width: 60%"><b>Ensemble des
                                                    bénévoles</b>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                    label="aaAssoNbBnvl" classeSupplementaire="integer-input-total text-right"
                                                    libelle="vide" [erreursCroisees]="['ctrlA41']">
                                                </bis-integer-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA41">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="99999" libelle="vide" 
                                                    label="aaAssoEtpBnvl"
                                                    classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlA42']">
                                                </bis-float-mask-input-keypad>
                                                <bis-affiche-erreurs-croisees colorErreur="danger"
                                                    [rootForm]="formulaire" labelErreur="ctrlA42">
                                                </bis-affiche-erreurs-croisees>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                juristes
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbBnvlJur" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpBnvlJur"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                psychologues
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbBnvlPsy" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpBnvlPsy"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right align-middle pl-2" style="width: 60%"><b>dont</b>
                                                travailleurs sociaux
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-integer-input-keypad [rootForm]="formulaire" [max]="9999"
                                                    label="aaAssoNbBnvlWsoc" classeSupplementaire="text-right"
                                                    libelle="vide">
                                                </bis-integer-input-keypad>
                                            </td>
                                            <td class="text-center align-middle pt-3" style="width: 20%">
                                                <bis-float-mask-input-keypad [rootForm]="formulaire" separatorLimit="9999" libelle="vide" 
                                                    label="aaAssoEtpBnvlWsoc"
                                                    classeSupplInput="text-right">
                                                </bis-float-mask-input-keypad>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </span>

            <div style="page-break-before: always"></div>

            <h5 class="mt-5 ml-2">A.3 - Formation des personnels Aide Aux Victimes salariés (CDI et CDD)</h5>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row pt-3">
                        <div class="col-md-2"></div>
                        <div class="col-md-9">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" [max]="99999"
                                classeColLabel="col-7" classeColInput="col-2" label="aaFormNbPers"
                                classeSupplInput="text-right">
                            </bis-integer-inline-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-10 ml-5">
                            <bis-float-mask-inline-input-keypad classeColLabel="col-8" classeColInput="col-2" [rootForm]="formulaire" 
                                separatorLimit="999999" maskFormat="separator.1"
                                label="aaFormNbJour"
                                classeSupplInput="text-right">
                            </bis-float-mask-inline-input-keypad>                            
                            <bis-affiche-alertes labelAlerte='alertA37'></bis-affiche-alertes>
                            <bis-affiche-alertes labelAlerte='alertA38'></bis-affiche-alertes>
                        </div>
                    </div>
                </div>
            </fieldset>

            <h5 class="mt-5 ml-2">A.4 - Les lieux de permanence des activités Aide Aux Victimes</h5>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card shadow bg-light rounded" style="border-width:2px">
                    <div class="card-header text-muted">
                        <i>Renseigner les informations demandées pour chacun des types de lieux de permanence<br>
                            Pour un même type de lieu, des permanences peuvent être tenues sur plusieurs sites
                            différents
                            Les informations doivent être indiquées par site
                        </i>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>A - Locaux de l'association (siège, antennes...)</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-asso></bis-lieux-asso>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>B - Tribunaux (hors permanence BAV)</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-tj></bis-lieux-tj>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>C - BAV au sein d'un tribunal</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-bav></bis-lieux-bav>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>D - Commissariats et Gendarmeries</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-polgend></bis-lieux-polgend>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>E - France services</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-frserv></bis-lieux-frserv>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>F - Services d'accès au droit (point-justice, MJD) hors France
                                Services</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-sad></bis-lieux-sad>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>G - Hôpitaux, UMJ et UAPED</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-hosto></bis-lieux-hosto>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>H - Mairies, collectivités territoriales, CCAS</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-colter></bis-lieux-colter>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>I - Autres lieux</b></div>
                        <div class="card-body">
                            <!-- Appel du composant fille qui gere la boucle -->
                            <bis-lieux-autr></bis-lieux-autr>
                        </div>
                    </div>
                    <div class="card shadow bg-light rounded pt-1 mr-1 ml-1">
                        <div class="card-header"><b>J - Total lieux</b></div>
                        <div class="card-body">
                            <div class="form-row pt-2">
                                <div class="col-md-6">
                                    <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuNbTot" [max]="999"
                                        enLectureSeule="true" classeColLabel="col-8" classeColInput="col-4"
                                        infoBulle="Cette zone est calculée automatiquement à partir du nombre total de type de lieu(x) ajouté(s)"
                                        [erreursCroisees]="['ctrlA103']">
                                    </bis-integer-inline-input>
                                    <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                        labelErreur="ctrlA103">
                                    </bis-affiche-erreurs-croisees>
                                </div>
                                <div class="col-md-6">
                                    <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuNbPermTot"
                                        [max]="99999" enLectureSeule="true" classeColLabel="col-8"
                                        classeColInput="col-4">
                                    </bis-integer-inline-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-10">
                                    <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuNbPermEtpTot"
                                        [max]="999999" enLectureSeule="true" classeColLabel="col-6"
                                        classeColInput="col-4">
                                    </bis-integer-inline-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-10">
                                    <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuNbVictTot"
                                        [max]="9999999" enLectureSeule="true" classeColLabel="col-6"
                                        classeColInput="col-4">
                                    </bis-integer-inline-input>
                                    <bis-affiche-alertes labelAlerte='alertA57'></bis-affiche-alertes>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div style="page-break-before: always"></div>

            <h5 class="mt-5 ml-2">A.5 - Services proposés</h5>
            <fieldset class="ml-2 mr-2 pt-2 pb-3">
                <h6 class="mt-1 ml-1">a - Visites à domicile</h6>
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row pt-3 pl-5">
                        <div class="col-md-11">
                            <bis-filtered-select-input-keypad [rootForm]="formulaire" label="aaServiVisitDom"
                                nomNomenclature="ouiNonNsp" [montreCode]="false">
                            </bis-filtered-select-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-9">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="aaServiVisitDomNb"
                                [max]="9999" classeColLabel="col-7" classeColInput="col-2">
                            </bis-integer-inline-input-keypad>
                        </div>
                    </div>
                </div>
                <h6 class="mt-3 ml-1">b - Dispositif d'urgence</h6>
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row pt-3">
                        <div class="col-md-12">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire" label="aaServiDispoUrge"
                                nomNomenclature="ouiNonNsp" [montreCode]="false" classeColLabel="col-6"
                                classeColInput="col-3" [erreursCroisees]="['ctrlA104']">
                            </bis-filtered-select-inline-input-keypad>
                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                labelErreur="ctrlA104">
                            </bis-affiche-erreurs-croisees>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire"
                                label="aaServiDispoUrgeNuit" nomNomenclature="ouiNon" [montreCode]="false"
                                classeColLabel="col-7" classeColInput="col-4">
                            </bis-filtered-select-inline-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire" label="aaServiDispoUrgeWe"
                                nomNomenclature="ouiNon" [montreCode]="false" classeColLabel="col-7"
                                classeColInput="col-4">
                            </bis-filtered-select-inline-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire"
                                label="aaServiDispoUrgeFerie" nomNomenclature="ouiNon" [montreCode]="false"
                                classeColLabel="col-7" classeColInput="col-4">
                            </bis-filtered-select-inline-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire"
                                label="aaServiDispoUrgeAutr" nomNomenclature="ouiNon" [montreCode]="false"
                                classeColLabel="col-7" classeColInput="col-4">
                            </bis-filtered-select-inline-input-keypad>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-10">
                            <bis-string-input [rootForm]="formulaire" label="aaServiDispoUrgeAutrDet" longueurMax=150>
                            </bis-string-input>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-9">
                            <bis-affiche-alertes labelAlerte='alertA58'></bis-affiche-alertes>
                        </div>
                    </div>
                   <div class="form-row">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <bis-filtered-select-inline-input-keypad [rootForm]="formulaire"
                                label="aaServiDispoUrgeActiv" nomNomenclature="ouiNon" [montreCode]="false"
                                classeColLabel="col-7" classeColInput="col-4">
                            </bis-filtered-select-inline-input-keypad>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-9">
                            <bis-affiche-alertes labelAlerte='alertA59'></bis-affiche-alertes>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-10">
                            <bis-integer-inline-input-keypad [rootForm]="formulaire" label="aaServiDispoUrgeNbVict"
                                [max]="9999" classeColLabel="col-8" classeColInput="col-2">
                            </bis-integer-inline-input-keypad>
                        </div>
                    </div>
                    <div *ngIf="this.formulaire.get('aaServiDispoUrgeActiv').enabled && aaServiDispoUrgeActiv === ''">
                        <br><br><br>
                    </div>
                </div>
            </fieldset>

            <div *ngIf="aaServiDispoUrge === ''">
                <br><br><br>
            </div>
        </form>
    </div>
</div>